import { render, staticRenderFns } from "./RelatedVacancies.vue?vue&type=template&id=0f80af7e&"
import script from "./RelatedVacancies.vue?vue&type=script&lang=js&"
export * from "./RelatedVacancies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports